/**
 * Returns a simple validation that checks if a value is a string
 * @param value: any
 * @returns true | false
 */
export function isString(value: any): value is string {
  return typeof value === 'string'
}

/**
 * Returns a simple validation that checks if a value is a number
 * @param value: any
 * @returns true | false
 */
export function isNumber(value: any): value is number {
  return typeof value === 'number'
}

/**
 * Returns a simple validation that checks if a value is an valid object
 * @param value: any
 * @returns true | false
 */
export function isObject<T>(value: T): value is T {
  return typeof value === 'object' && !Array.isArray(value) && value !== null
}

/**
 * Returns a simple validation that checks if a value is an valid array
 * @param value: any
 * @returns true | false
 */
export function isArray<T>(value: T): value is T {
  return Array.isArray(value)
}

/**
 * A value's type for a diagnostic: `'null'` for null and `'array'` for an
 * array, which `typeof` would both call `'object'`, and `typeof` otherwise.
 * Shared by the authored-config reports in `processConfig` and
 * `confirmOrderDialog`, so the facet reads the same in both.
 * @param value: unknown
 * @returns string
 */
export function describeType(value: unknown): string {
  if (value === null) {
    return 'null'
  }
  if (Array.isArray(value)) {
    return 'array'
  }
  return typeof value
}
